import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import bloglettersReducer from '../reducers/blogletters';
import thunk from 'redux-thunk';
import authReducer from '../reducers/auth';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(combineReducers({data: bloglettersReducer, auth: authReducer}), composeEnhancers(applyMiddleware(thunk)));

export default store; 